import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/listings")({
  component: lazyRouteComponent(() => import("@/pages/admin/Listings")),
});
